module.exports = __webpack_public_path__ + "static/img/公众号二维码.f31752f5.jpg";